import { c as _c } from "react/compiler-runtime";
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { formatPrice } from '@winelidays/wld-tsx-2/utils';
const FeesDetailLine = t0 => {
    const $ = _c(13);
    const { fees } = t0;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    let t1;
    if ($[0] !== translate) {
        t1 = translate("availability.calculated_price.fees.label");
        $[0] = translate;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const label = t1;
    let t2;
    if ($[2] !== currencySymbol || $[3] !== fees || $[4] !== translate) {
        t2 = translate("messages.price_with_currency", {
            price: formatPrice(fees),
            currencySymbol
        });
        $[2] = currencySymbol;
        $[3] = fees;
        $[4] = translate;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    const value = t2;
    let t3;
    if ($[6] !== label) {
        t3 = <span className="text-gray-400">{label}</span>;
        $[6] = label;
        $[7] = t3;
    }
    else {
        t3 = $[7];
    }
    let t4;
    if ($[8] !== value) {
        t4 = <span>{value}</span>;
        $[8] = value;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
        t5 = <div className="flex flex-row justify-between py-1">{t3}{t4}</div>;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    }
    else {
        t5 = $[12];
    }
    return t5;
};
export default FeesDetailLine;
